export default {
  methods: {
    newUuidKey(num = 1) {
      const uuid = require('uuid/v4');
      return `${uuid()}${num}`;
    },
  },
};
